import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "success-check",
  "use": "success-check-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"success-check\"><path fill-rule=\"evenodd\" d=\"M2 7.749l1.363-1.346L6.286 9.3 12.637 3 14 4.354 6.286 12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol